<template>
    <div class="dialog"v-bind:class="{'dialog-blue':isBlue}" @click="goTo">
        <p class="dialog_name"  v-html="getCharacter.name" v-if="showName"></p>
        <p class="dialog_name" v-if="!showName"></p>
        <p class="dialog_text" v-html="text"v-if="!centerText" ></p>
        <p class="dialog_text center-text" v-html="text"  v-if="centerText"></p>
        <div class="dialog_next" v-if="showNext" >
            <ruby>次<rt>つぎ</rt>へ</ruby><img
                src="assets/img/next.png" class="blink-1">
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "CharacterTalk",
        computed: {
            ...mapGetters(['getCharacter']),
            showNextComputed() {
                return this.showNext ? this.showNext : true;
            }
        },
        data() {
            return {
                allTextAppear: true
            }
        },
        methods: {
            goTo() {
                if (this.route) {
                    this.$router.push(this.route);
                } else {
                    this.$emit('action');
                }
            }
        },
        props: ['text', 'route', 'showNext', 'isBlue', 'showName' , 'centerText']
    }
</script>

<style lang="scss" scoped>
    .center-text{
        text-align: center;
    }
</style>
